import { AccountingEntriesOverrideFieldsConfiguration } from '~modules/connectors/services/extract-connectors-configurations/field-type';

export const fecOverrideTransformationFieldsConfiguration : AccountingEntriesOverrideFieldsConfiguration = {
    paymentProcessorConfiguration: {
        entryDescription: {
            disable: true
        },
        client: {
            account: {
                defaultValue: '411'
            }
        },
        supplier: {
            account: {
                defaultValue: '401'
            }
        }
    },

    buyInvoiceProcessorConfiguration: {
        entryDescription: {
            disable: true
        },
        thirdPartyAccount: {
            account: {
                defaultValue: '401'
            }
        }
    },

    sellInvoiceProcessorConfiguration: {
        entryDescription: {
            disable: true
        },
        thirdPartyAccount: {
            account: {
                defaultValue: '411'
            }
        }
    },

    bankProcessorConfiguration: {
        entryDescription: {
            disable: true
        },
        client: {
            account: {
                defaultValue: '411'
            }
        },
        supplier: {
            account: {
                defaultValue: '401'
            }
        }
    },

    analyticProcessorConfiguration: {
        disable: true
    }
}